import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from 'lucide-react';
import { ReportNavContext } from '../reportNav';
import { pageHasHelp } from '../../data/pageHelp';
import { guide, useGuide } from './guideStore';
import './GuideButton.css';

/* Le CHEMIN (2026-09-16) : il allume les repères du Guide sur la page. Il vit
   dans la BARRE SUPÉRIEURE, à côté de la roue dentée, une place fixe quelle
   que soit la page (il a été à côté du titre, puis au bout des onglets : il
   changeait de place d'un écran à l'autre et on ne le trouvait pas). Toujours
   présent, ATTÉNUÉ quand la page n'a rien à montrer, comme l'icône
   télécharger : une icône qui disparaît ferait bouger la barre. Allumé, il
   passe en ambre, la couleur des repères. */
export default function GuideButton({ page: pageProp = null }) {
  const { t } = useTranslation();
  const nav = useContext(ReportNavContext);
  const g = useGuide();
  const page = pageProp || (nav ? nav.page : null);
  const has = !!page && pageHasHelp(page);
  return (
    <button
      type="button"
      className={`gd-toggle${g.on && has ? ' is-on' : ''}${has ? '' : ' is-empty'}`}
      onClick={() => { if (has) guide.toggle(); }}
      disabled={!has}
      title={has ? t('common:guide.toggleTitle') : t('common:guide.none')}
      aria-label={has ? t('common:guide.toggleTitle') : t('common:guide.none')}
      aria-pressed={g.on && has}
      data-tour="guide-button"
    >
      <Route size={17} strokeWidth={1.6} aria-hidden="true" />
    </button>
  );
}
